// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2Vy00","text":"SelectPayment_text__2syWb","title":"SelectPayment_title__5UP0J","btn":"SelectPayment_btn__3jY1m"};